/** @jsxImportSource @emotion/react */

import { Empty, Form, Select, SelectProps } from "antd";
import { ValidateStatus } from "antd/es/form/FormItem";
import { Control, Controller, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SelectCustomStyle } from "./index.style";

interface SelectCustomProps extends SelectProps {
  dropdownBackground?: string;
  name?: string;
  control?: Control<FieldValues | any>;
  defaultValue?: any;
  error?: string;
  validate_status?: ValidateStatus;
  defaultValueSelect?: any;
  label?: string;
}

const SelectCustom = (props: SelectCustomProps) => {
  const {
    dropdownBackground,
    name = "",
    control,
    defaultValue,
    error,
    label,
    validate_status,
    defaultValueSelect,
    ...rest
  } = props;
  const { i18n } = useTranslation();
  const dropdownStyle = {
    padding: "10px",
    backgroundColor: dropdownBackground ? dropdownBackground : "white",
  };
  return (
    <div css={SelectCustomStyle.self}>
      {control ? (
        <Form.Item
          label={
            label ? (
              <p style={{ fontSize: "16px", color: "white" }}>{label}</p>
            ) : null
          }
          labelCol={{ span: 24 }}
          help={error}
          validateStatus={validate_status}
        >
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({
              field: { onChange: _onChange, value },
              formState: { errors },
            }) => (
              <Select
                {...rest}
                dropdownStyle={dropdownStyle}
                onChange={_onChange}
                defaultValue={defaultValueSelect}
                value={value === "" ? undefined : value}
                notFoundContent={
                  <Empty description={i18n.t("message:Empty")} />
                }
              />
            )}
          />
        </Form.Item>
      ) : (
        <Select
          {...rest}
          dropdownStyle={dropdownStyle}
          defaultValue={defaultValue}
        />
      )}
    </div>
  );
};

export default SelectCustom;
